import { Link, Typography, useTheme } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import { MuiFontSizeParam } from "../../types/muiTypes";

interface TextLinkTemplateProps {
  leadText: string;
  linkText: string;
  href: string;
  appendHref: boolean;
  fontSizeParam?: MuiFontSizeParam;
}

export const TextLinkTemplate: React.FC<TextLinkTemplateProps> = ({
  leadText,
  linkText,
  href,
  appendHref,
  fontSizeParam = { xs: "medium", md: "x-large" },
}) => {
  const theme = useTheme();
  const location = useLocation();

  function buildPath() {
    const cleanHref = href.replace(/^\//, ""); // drop a leading “/” if present
    if (appendHref) {
      const base = location.pathname.replace(/\/$/, ""); // drop trailing “/” on current path
      return `${base}/${cleanHref}`;
    }
    return `/${cleanHref}`;
  }

  const path = buildPath();

  return (
    <Typography
      variant="body1"
      component="p" /* renders a <p> for semantics */
      sx={{
        textAlign: "center",
        fontSize: fontSizeParam,
        mb: 2,
        lineHeight: 1.6 /* optional: tweak rhythm */,
      }}
    >
      {leadText}{" "}
      <Link
        underline="always"
        href={path}
        color={theme.palette.primary.main}
        variant="inherit" /* keeps font-size in sync */
        sx={{ "&:hover": { cursor: "pointer" } }}
      >
        {linkText}
      </Link>
    </Typography>
  );
};
